namespace Portico.Directives {

    import services = Portico.Services;

    export interface ITcFocusController {
        tcForm: ITcFormController;
        tcInput: ITcInputController;
    }

    export class TcFocusController implements ITcFocusController {
        tcForm: ITcFormController;
        tcInput: ITcInputController;
    }

    angular.module('app').directive('tcFocus', ['$timeout', ($timeout: angular.ITimeoutService) => {
        return {
            bindToController: { },
            controller: <any>TcFocusController,
            controllerAs: '$focus',
            link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: any[]) => {
                const tcFocus: ITcFocusController = $ctrl[0];
                const tcForm: ITcFormController = $ctrl[1];
                const tcInput: ITcInputController = $ctrl[2];

                tcFocus.tcForm = tcForm;
                tcFocus.tcInput = tcInput;

                $timeout(() => {
                    //let tcInput = tcFocus.tcInput;

                    //if (!tcInput) {
                    //    tcInput = tcFocus.tcForm.tcInputs[0];
                    //}

                    //$('#' + tcInput.id + '-input').focus();
                    $element.find("a, button, input, select, textarea").first().focus();
                }, 50);
            },
            restrict: 'A',
            require: ['tcFocus', '?^tcForm', '?^tcInput'],
            scope: true,
        };
    }]);
}